module.exports = __webpack_public_path__ + "img/postulation-icon.2faa6c7a.svg";